<p>emptypage works!</p>


<button class="btn btn-secondary" (click)="doStuff()">Test</button>